<div *ngIf="loading" [class.fullscreen]="fullscreen" class="loader-container">
  <span class="pageloader"></span>
</div>

